// ===================== separate images text =====================


// --------upper text --------------

if ($(window).width() > 767) {
  var maxHeight = 0;
  $(".sub-heading p").each(function(){
    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".sub-heading p").height(maxHeight);


  // ------------ heading ----------------

  var maxHeight = 0;
  $(".heading_contents h1").each(function(){
    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".heading_contents h1").height(maxHeight);


  // ----------- text -------------

  var maxHeight = 0;
  $(".heading_contents p").each(function(){
    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".heading_contents p").height(maxHeight);
}

// ========== variatnt tooltip ==================

$(document).ready(function(){
  $(".variant-input.tooltip-product").mouseenter(function(){
    $('.tooltiptext-product').text($(this).attr('data-value'))
  })
})

// ================ pop up ============================

$('.template-index .text-colume-main .grid__item.medium-up--one-half').on('click',function(){
  console.log('okok')
  $(this).parents('.template-index .text-colume-main').find('#myModal').attr('style','display:block');
  $(this).addClass('Modal-open');
})


$(document).on('click','.grid__item.medium-up--one-third',function(){
  $(this).parents('.text-colume-main').find('#myModal').attr('style','display:block');
  $(this).addClass('Modal-open');
})


$(document).on('click','.modal-content .close',function(){
  $(this).parents('.text-colume-main').find('#myModal').attr('style','display:none !important');
  $('.grid__item.medium-up--one-third').removeClass('Modal-open');
})


// =========== pop up product page =================



$(document).on('click','.product-icon-all .product-icon-main',function(){
  $('#myModal').removeClass('show-modal')
  window.click = $(this).index();
  $('.popup_content-all #myModal').each(function(){
    window.popup = $(this).index();
    if( click == popup ){
      $(this).addClass('show-modal');
    }  
  })
})


$(document).on('click','.popup_content-all .modal-content .close',function(){
  $('.popup_content-all #myModal').removeClass('show-modal')
})



// =============== popup ingredients ===================


$(document).on('click','.popup_headings li',function(){
  console.log('clicked')
  $('#myModal').removeClass('show-modal')
  window.click = $(this).index();
  $('.popup_content #myModal').each(function(){
    window.popup = $(this).index();
    if( click == popup ){
      $(this).addClass('show-modal');
    }
  })
})


$(document).on('click','.modal-content .close',function(){
  $('.popup_content #myModal').removeClass('show-modal');
})

// =====================  image text slider =================


if ($(window).width() < 768) {
  $('.slickyy-image').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
    ]
  });
}

// =============== featured collection slider ==================  


$(document).ready(function(){
  
  $('#shopify-section-template--15678899912872__1654699428a0456966').removeClass('index-section')
  $('.grid__item.grid-newsletter button , .grid__item.grid-newsletter button span').removeClass('collapsible-trigger,collapsible-trigger__icon')
  
    $('.grid-overflow-wrapper .grid.grid--uniform').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      nextArrow: '<svg class="next" viewBox="0 0 100 100" aria-hidden="true" data-acsb-hidden="true" data-acsb-force-hidden="true"><path d="M 20,50 L 70,100 L 80,90 L 40,50  L 80,10 L 70,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
      prevArrow: '<svg class="prev" viewBox="0 0 100 100" aria-hidden="true" data-acsb-hidden="true" data-acsb-force-hidden="true"><path d="M 20,50 L 70,100 L 80,90 L 40,50  L 80,10 L 70,0 Z" class="arrow"></path></svg>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            dots: true
          }
        },
        {
          breakpoint: 589,
          settings: "unslick"
        }
      ]
    });
})


$('.template-blog .grid.grid--no-gutters').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: '<svg class="next" viewBox="0 0 100 100" aria-hidden="true" data-acsb-hidden="true" data-acsb-force-hidden="true"><path d="M 20,50 L 70,100 L 80,90 L 40,50  L 80,10 L 70,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
  prevArrow: '<svg class="prev" viewBox="0 0 100 100" aria-hidden="true" data-acsb-hidden="true" data-acsb-force-hidden="true"><path d="M 20,50 L 70,100 L 80,90 L 40,50  L 80,10 L 70,0 Z" class="arrow"></path></svg>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 589,	
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    }
  ]
});



// ===================== home logo=====================



$('.logo-bar').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 589,	
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    }
  ]
});



$('.additional-logo').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 6,
  autoplay: true,
  autoplaySpeed: 3000,  
  arrows:true,
  nextArrow: '<svg class="next" viewBox="0 0 100 100" aria-hidden="true" data-acsb-hidden="true" data-acsb-force-hidden="true"><path d="M 20,50 L 70,100 L 80,90 L 40,50  L 80,10 L 70,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
  prevArrow: '<svg class="prev" viewBox="0 0 100 100" aria-hidden="true" data-acsb-hidden="true" data-acsb-force-hidden="true"><path d="M 20,50 L 70,100 L 80,90 L 40,50  L 80,10 L 70,0 Z" class="arrow"></path></svg>',
  responsive: [
    {
      breakpoint: 1050,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 890,	
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 767,	
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
      }
    },
    {
      breakpoint: 450,	
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: false,
        arrows:true,
        nextArrow: '<svg class="next" viewBox="0 0 100 100" aria-hidden="true" data-acsb-hidden="true" data-acsb-force-hidden="true"><path d="M 20,50 L 70,100 L 80,90 L 40,50  L 80,10 L 70,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
        prevArrow: '<svg class="prev" viewBox="0 0 100 100" aria-hidden="true" data-acsb-hidden="true" data-acsb-force-hidden="true"><path d="M 20,50 L 70,100 L 80,90 L 40,50  L 80,10 L 70,0 Z" class="arrow"></path></svg>',

      }
    }
  ]
});

// ====================== product page ===============


$(document).bind('DOMNodeInserted', function(e) {
  var element = e.target;
  var elm = $(element).attr("class")
  //     warn(elm)
  if(typeof elm != 'undefined'){
    if(elm.indexOf('product-recommendations')>-1){
      $('.product-single__related').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        nextArrow: '<svg class="next" viewBox="0 0 100 100" aria-hidden="true" data-acsb-hidden="true" data-acsb-force-hidden="true"><path d="M 20,50 L 70,100 L 80,90 L 40,50  L 80,10 L 70,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
        prevArrow: '<svg class="prev" viewBox="0 0 100 100" aria-hidden="true" data-acsb-hidden="true" data-acsb-force-hidden="true"><path d="M 20,50 L 70,100 L 80,90 L 40,50  L 80,10 L 70,0 Z" class="arrow"></path></svg>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: false,
              dots: true
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: false,
              dots: true
            }
          },
          {
            breakpoint: 589,
            settings: "unslick"
          }
        ]
      });
    }
  }
});

// ============================================



$('.product-logo-img-mian').slick({
  dots: false,
  cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 3000,
  fade: true,
});



// $('.icon-slicky').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 900,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         infinite: false,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 767,
//       settings: "unslick"
//     },
//     {
//       breakpoint: 400,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         infinite: false,
//         dots: false
//       }
//     }
//   ]
// });


// ===================product tabs sticky======================


$(document).ready(function(){
  if($('body.template-product').length > 0 && $('body.template-product #myHeader').length > 0 ){
    window.onscroll = function() {myFunction()};

    var header = document.getElementById("myHeader");
    var sticky = header.offsetTop;

    function myFunction() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }
  }
})

// product tab mobile =========================



let answers=document.querySelectorAll(".accordion__question");
answers.forEach((event)=>{
  event.addEventListener('click',()=>{
                         if(event.classList.contains("active")){
    event.classList.remove("active");
  }
  else{
    event.classList.add("active");
  }
})
})

// ========================= product tab click animation ========


$(function() {
  $('a[href*=\\#]:not([href=\\#])').on('click', function() {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.substr(1) +']');
    if (target.length) {
      $('html,body').animate({
        scrollTop: target.offset().top - 50
      }, 500);
      return false;
    }
  });
});


